var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.reason)?_c('div',{staticClass:"order-detail-section mg20"},[_c('h3',[_vm._v("修订理由：")]),_vm._v(" "),_c('div',{staticStyle:{"padding":"4px 24px"}},[_vm._v(_vm._s(_vm.reason))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13287df3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/partial/order_reason.vue
// module id = 2345
// module chunks = 0